import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';
import LanguageDetector from 'i18next-browser-languagedetector';

import nlTranslation from './locales/nl/translation.json';
import frTranslation from './locales/fr/translation.json';
import deTranslation from './locales/de/translation.json';
import enTranslation from './locales/en/translation.json';

const resources = {
  nl: { translation: nlTranslation },
  fr: { translation: frTranslation },
  de: { translation: deTranslation },
  en: { translation: enTranslation }
};

i18n
  .use(LanguageDetector)
  .use(initReactI18next)
  .init({
    resources,
    fallbackLng: 'nl', // Dutch as default for Belgium
    supportedLngs: ['nl', 'fr', 'de', 'en'],

    detection: {
      // Detection order and caches
      order: ['querystring', 'localStorage', 'navigator'],
      caches: ['localStorage'],
      lookupQuerystring: 'lang',
      lookupLocalStorage: 'preferred_language'
    },

    interpolation: {
      escapeValue: false // React already escapes by default
    },

    react: {
      useSuspense: false
    }
  });

export default i18n;
